<!--
<h2 *ngIf="!loading">Login</h2>
<form [formGroup]="loginForm" (ngSubmit)="getUserUPNInfo()" *ngIf="!loading">
  <div class="form-group">
    <label for="username">Username</label>
    <input type="text" formControlName="username" class="form-control"  />

  </div>

  <div class="form-group">
    <button class="btn btn-primary">
      <span  class="spinner-border spinner-border-sm mr-1"></span>
      Login
    </button>

  </div>
</form> -->

@if (!isIframe) {
  <router-outlet ></router-outlet>
}